import { ColumnProps } from "@monolith-forensics/monolith-ui";
import { File } from "../files.types";
import {
  CaseFileStatusComponent,
  FileComponent,
  FilePathComponent,
  FolderComponent,
} from "../components";
import convertBytesToSize from "@/utils/convertBytesToSize";
import { monolithMoment } from "@/utils/date-format";

export const CaseFileDefinitions: ColumnProps[] = [
  {
    dataField: "uuid",
    caption: "UUID",
    visible: false,
  },
  {
    dataField: "name",
    caption: "Name",
    render: ({ rowData }: { rowData: File }) => {
      if (rowData?.is_folder) {
        return <FolderComponent data={rowData} />;
      }
      return <FileComponent data={rowData} onClick={() => {}} />;
    },
  },
  {
    dataField: "type",
    caption: "Type",
    render: ({ rowData }: { rowData: File }) => {
      return rowData?.is_folder ? "Folder" : "File";
    },
  },
  {
    dataField: "status",
    caption: "Status",
    render: ({ rowData }: { rowData: File }) => {
      return <CaseFileStatusComponent file={rowData} />;
    },
  },
  {
    dataField: "size",
    caption: "Size",
    render: ({ rowData }: { rowData: File }) =>
      convertBytesToSize(rowData.size),
  },
  {
    dataField: "ext",
    caption: "Extension",
  },
  {
    dataField: "path",
    caption: "Path",
    visible: false,
    render: ({ rowData }: { rowData: File }) => {
      return <FilePathComponent data={rowData} />;
    },
  },
  {
    dataField: "created_on",
    caption: "Created On",
    visible: false,
    render: ({ rowData }: { rowData: File }) => {
      return monolithMoment({
        timestamp: rowData.created_on,
        includeTime: true,
        includeZone: true,
      });
    },
  },
  {
    dataField: "client_modified",
    caption: "Client Modified",
    visible: false,
    render: ({ rowData }: { rowData: File }) => {
      if (!rowData.client_modified) {
        return "";
      }
      return monolithMoment({
        timestamp: rowData.client_modified,
        includeTime: true,
        includeZone: true,
      });
    },
  },
  {
    dataField: "created_by",
    caption: "Created By",
    visible: false,
    render: ({ rowData }: { rowData: File }) => rowData.created_by?.full_name,
  },
  {
    dataField: "md5",
    caption: "MD5",
    visible: false,
  },
  {
    dataField: "sha1",
    caption: "SHA1",
    visible: false,
  },
  {
    dataField: "sha256",
    caption: "SHA256",
    visible: false,
  },
  {
    dataField: "description",
    caption: "Description",
    visible: false,
  },
];
